export const getPostAuthors = (postAuthors, allAuthors) => {
  if (!postAuthors) {
    return [];
  }

  const authorsArray = postAuthors.map((authorId, idx) => {
    return {
      postId: Number(authorId),
      orderNo: idx + 1,
    };
  });

  const findAuthors = (authorItem) => authorsArray.find((authorObj) => authorItem.databaseId === Number(authorObj.postId));

  return allAuthors
    .filter((author) => findAuthors(author))
    .map((author) => {
      const item = findAuthors(author);
      return {
        name: author.title,
        slug: author.slug,
        id: author.databaseId,
        orderNo: item.orderNo
      };
    })
    .sort((postA, postB) => postA.orderNo - postB.orderNo);
};

export const getIssueAuthors = (posts, allAuthors) => {
  const authorIds = posts.flatMap((post) => post.tghpwipArticleAuthor);

  return getPostAuthors(authorIds, allAuthors).map((postAuthor) => {
    const authorsFoundPost = posts.filter((post) =>
      post?.tghpwipArticleAuthor.find((id) => Number(id) === Number(postAuthor.id)),
    );

    return {
      name: postAuthor.name,
      slug: authorsFoundPost[0].slug,
    };
  });
};

export const getStickySortedAuthors = (allAuthors, allPosts) => {
  allPosts = allPosts.filter((post) => post.tghpwipPostIsPreview !== '1');

  const sortedAuthorList = allAuthors.sort((authorA, authorB) =>
    authorA.slug > authorB.slug ? 1 : -1,
  );
  const authorsWithPosts = getAuthorsWithPosts(sortedAuthorList, allPosts);

  const stickyAuthors = authorsWithPosts.filter((author) => author.tghpwipAuthorStickyPost === '1');
  const restAuthors = authorsWithPosts.filter((author) => author.tghpwipAuthorStickyPost !== '1');

  return [...stickyAuthors, ...restAuthors];
};

export const getAuthorsWithPosts = (authorList, allPosts) => {
  return authorList.map((authorObj) => {
    const authorPosts = allPosts.filter((post) => {
      return post?.tghpwipArticleAuthor.find(
        (authorId) => authorObj.databaseId === Number(authorId),
      );
    });

    return {
      ...authorObj,
      articles: authorPosts,
    };
  });
};

export const stripEntities = (string) =>
  string.replace('%ef', '').replace('%bf', '').replace('%bc', '');

export const getAuthorUrl = (slug) => `/our-authors/#${stripEntities(slug)}`;
